import gql from 'graphql-tag'

export const CHEF_QUERY = gql`
  query GetChef($id: ID!, $date: DateTime) {
    chef: getUser(id: $id) {
      id
      avatar
      firstName
      lastName
      description
      story
      sellerRating
      sellerProducts {
        id
        name
        photo
        price
        currencyCode
        tags
        left(date: $date)
      }
      sellerSchedule {
        status
        mon
        tue
        wed
        thu
        fri
        sat
        sun
      }
      agreements {
        halal
      }
      slug
      # isFollowed
    }
  }
`

export const SEARCH_CHEFS_QUERY = gql`
  query FindChefs(
    $delivery: DeliveryInput!
    $productsFirst: Int
    $productsDate: DateTime!
  ) {
    # chefs: chefs(location: $location) {
    chefs(delivery: $delivery) {
      id
      avatar
      firstName
      lastName
      description
      story
      tags
      sellerRating
      sellerProducts(first: $productsFirst) {
        id
        name
        photo
        price
        currencyCode
        tags
        left(date: $productsDate)
      }
      slug
      # isFollowed
    }
  }
`

export const FOLLOW_CHEF_MUTATION = gql`
  mutation FollowChef($id: ID!) {
    followChef(id: $id) {
      isFollowed
    }
  }
`
export const UNFOLLOW_CHEF_MUTATION = gql`
  mutation UnfollowChef($id: ID!) {
    unfollowChef(id: $id) {
      isFollowed
    }
  }
`
